import BackArrow from "../../Atoms/BackArrow/BackArrow";
import submenuDesplazableVariant from "../../../services/variants/submenuDesplazable";
import { motion } from "framer-motion";
import { useLocation } from "wouter";
import ActiveLink from '../../Atoms/ActiveLink/ActiveLink';
import "./SubmenuDesplazable.scss";
import { breakPointMenuFixed } from "../../../services/variants/config";
import { useContext, useState } from "react";
import MenuContext from "../../../context/MenuContext";

const SubmenuDesplazable = ({ setShowSubmenu, showSubmenu, setShowMenuMovil }) => {
  const [, setLocation] = useLocation()
  const [fillArrow, setFillArrow] = useState('151B26')
  const [titleMenuColor, setTitleMenuColor] = useState('c-dark')
  const { setIsMenuOpen } = useContext(MenuContext)  
  const viewportWidh = window.innerWidth

  const hideSubmenuHandler = () => {
    setShowSubmenu(false)
    setIsMenuOpen(false)
  }

  const clickHandler = (route) => {
    setShowMenuMovil && setShowMenuMovil(false)
    viewportWidh <= breakPointMenuFixed && hideSubmenuHandler();
    return setLocation(route);
  };

  window.addEventListener('resize', () => hideSubmenuHandler()) // Si hago resize cierro el submenu

  const onMouseLeave = (e) => {
    Array.from(document.getElementsByClassName('menu-vertical__item')).forEach(item => {
      if(item.getAttribute('class').includes('activeHover')){
        item.classList.remove('activeHover')
      }
    })
  };

  const handleMouseEnterArrow = () => {
    setFillArrow('#0466C8')
    setTitleMenuColor('c-blue')
  }

  const handleMouseLeaveArrow = () => {
    setFillArrow('#151B26')
    setTitleMenuColor('c-dark')
  }

  return (
    <motion.div
      variants={submenuDesplazableVariant}
      initial="hidden"
      animate="visible"
      exit="exit"
      className={`submenuDesplazable--container`}
      onMouseLeave={onMouseLeave}
    >
      <div className="submenuDesplazable--item-container s-cross-center pl-10" onClick={hideSubmenuHandler} onMouseEnter={handleMouseEnterArrow} onMouseLeave={handleMouseLeaveArrow}>
        <span className="mr-10 submenuDesplazable--span" >
          <BackArrow fill={fillArrow} />
        </span>
        <h2 className={`submenuDesplazable--title source-20 bold ${titleMenuColor}`}>{showSubmenu.title}</h2>
      </div>
      {showSubmenu.items.map((item, index) => (
        <ActiveLink
          href={item.route}
          customClass="submenuDesplazable--item-container hover s-cross-center pr-35 pl-35"
          key={index}
          handleClick={() => clickHandler(item.route)}
         >
          <p className="source-16" >{item.text}</p>
        </ActiveLink>
      ))}
    </motion.div>
  );
};

export default SubmenuDesplazable;
